module.exports = __webpack_public_path__ + "img/13_8.e9b289c9.png";